import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CloseOffer } from '../../services/api';
import { submitApplicationData } from '../../services/applicationApi';
import { transformFormDataToDDA } from '../../utils/dataTransform';
import { SideMenu, TopMenu } from 'maxcu-shared-lib';
import usePreventBack from '../../hooks/usePreventBack';
import './EndPage.css';
import menuItems from '../SideMenu/menuItems';

const EndPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [submissionStatus, setSubmissionStatus] = useState('submitting');
    const formData = location.state?.formData;

    const [isCollapsed, setIsCollapsed] = useState(false);


  
    const handleResize = () => {
      if (window.innerWidth < 600) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };
  
    useEffect(() => {
      handleResize(); // Initial check
      window.addEventListener('resize', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    // Use the prevent back hook
    usePreventBack();

    useEffect(() => {
        const submitApplication = async () => {
            try {
                // Transform form data to DDA format
                const ddaData = transformFormDataToDDA(formData);
                
                // First API call - submit application
                const submitResponse = await submitApplicationData(ddaData);

                if (submitResponse.Success) {
                    // Second API call - tracking
                    try {
                         // Debug log
                        await CloseOffer(formData.loan_type);
                        setSubmissionStatus('success');
                    } catch (trackingError) {
                        
                        // We still consider it a success even if tracking fails
                        setSubmissionStatus('success');
                    }
                } else {
                    setSubmissionStatus('error');
                }
            } catch (error) {
                
                setSubmissionStatus('error');
            }
        };

        if (formData) {
            submitApplication();
        } else {
            setSubmissionStatus('error');
        }
    }, [formData]);

    const goToHome = () => {
        navigate('/');
    };

    if (submissionStatus === 'submitting') {
        return (
            <div className="end-page">
                <SideMenu menuItems={menuItems} />
                {isCollapsed && <TopMenu />}
                <div className="main-content">
                    <div className="end-page-container">
                        <div className="end-page-content">
                            <h1>Submitting Your Application</h1>
                            <p>Please wait while we process your application...</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (submissionStatus === 'error') {
        return (
            <div className="end-page">
                <SideMenu menuItems={menuItems} />
                {isCollapsed && <TopMenu />}
                <div className="main-content">
                    <div className="end-page-container">
                        <div className="end-page-content">
                            <h1>Submission Error</h1>
                            <p>We encountered an error while submitting your application.</p>
                            <p>Please try again or contact support if the problem persists.</p>
                            <button className="btn primary" onClick={goToHome}>Return to Home</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="end-page">
            <SideMenu menuItems={menuItems} />
            {isCollapsed && <TopMenu />}
            <div className="main-content">
                <div className="end-page-container">
                    <div className="end-page-content">
                        <h1>Thank You!</h1>
                        <p>Your application has been submitted successfully.</p>
                        <p>We will review your application and contact you soon.</p>
                        <button className="btn primary" onClick={goToHome}>Return to Home</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EndPage;
